import { render } from "./FooterVue.vue?vue&type=template&id=7402db41"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__